import { Card } from 'layouts'
import { Button, DatePicker, Select, message } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useState, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import {
    LocationSlice,
    getLocationListDataAction,
    FleetSummarySlice,
    NavSlice,
    getALocationDataAction,
} from 'redux/reducers'
import moment from 'moment'
import './ComFullCalendar.scss'
import './YearFullCalendar.scss'
import { setStroage, getStroage } from 'utils'

// 其他插件...
export const YearFullCalendar = props => {
    const { t } = useTranslation()
    const { authLocationList, typeString, typeSlice, typeApi, eventList, typeRoute } = props
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [btnType, setBtnType] = useState('dayGridMonth') // 按钮类型
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const selectedKeys = useSelector(state => state.NavSlice.selectedKeys)
    const yearDate = useSelector(state => state.FleetSummarySlice.yearDate)
    const language = getStroage('language')

    const locationData = useSelector(state => state.LocationSlice.locationData)
    const locationType = useSelector(state => state.LocationSlice.locationType)
    let congruentLocation
    if (locationType === '') {
        congruentLocation = false
    } else if (locationData?.length !== 1 || locationType !== 'outdoor') {
        congruentLocation = true
    }

    // 年视图区域///////////////////////////////////////
    const [year, setYear] = useState(Number(yearDate) ?? new Date().getFullYear())

    // 获取 API 数据
    useEffect(() => {
        if (getStroage('btnType') == []) {
            setStroage('btnType', 'dayGridMonth')
        }
        isShowProjectSummaryAndHseDiary(setBtnType(getStroage('btnType')), null)
        dispatch(FleetSummarySlice.actions.addYearDate(String(year)))
    }, [year])

    // 切换年份
    const changeYear = increment => {
        setYear(prevYear => prevYear + increment)
    }

    // 年日期限制
    const yearDateValidRange = () => {
        if (userInfo) {
            if (typeRoute === 'acquisition_obn') {
                return {
                    isStart: userInfo?.project?.acquisitionStartDate < yearDate,
                    isEnd: dayjs(userInfo?.project?.acquisitionEndDate).add(1, 'day').format('YYYY-MM-DD') > yearDate,
                    start: userInfo?.project?.acquisitionStartDate,
                    end: dayjs(userInfo?.project?.acquisitionEndDate).add(1, 'day').format('YYYY-MM-DD'),
                }
            }
            if (typeRoute === 'activity_diary') {
                return {
                    isStart: userInfo?.project?.activityDiaryStartDate < yearDate,
                    isEnd: dayjs(userInfo?.project?.activityDiaryEndDate).add(1, 'day').format('YYYY-MM-DD') > yearDate,
                    start: userInfo?.project?.activityDiaryStartDate,
                    end: dayjs(userInfo?.project?.activityDiaryEndDate).add(1, 'day').format('YYYY-MM-DD'),
                }
            }
            if (typeRoute === 'receiver') {
                return {
                    isStart: userInfo?.project?.receiverStartDate < yearDate,
                    isEnd: dayjs(userInfo?.project?.receiverEndDate).add(1, 'day').format('YYYY-MM-DD') > yearDate,
                    start: userInfo?.project?.receiverStartDate,
                    end: dayjs(userInfo?.project?.receiverEndDate).add(1, 'day').format('YYYY-MM-DD'),
                }
            } else {
                return {
                    isStart: userInfo?.project?.firstReportDate < yearDate,
                    isEnd: dayjs(userInfo?.project?.lastReportDate).add(1, 'day').format('YYYY-MM-DD') > yearDate,
                    start: userInfo?.project?.firstReportDate,
                    end: dayjs(userInfo?.project?.lastReportDate).add(1, 'day').format('YYYY-MM-DD'),
                }
            }
        } else {
            return {}
        }
    }

    const locationId = useSelector(state => state.LocationSlice.locationId)
    const locationName = useSelector(state => state.LocationSlice.locationName)
    //回显
    const calendarData = useSelector(state => state[typeString].calendarData)

    /* 切换日期 */
    const handleDatePicker = (date, dateString) => {
        dispatch(FleetSummarySlice.actions.addYearDate(dateString))
    }
    //判断是否在项目总结和Hse日志模块内
    const isShowProjectSummaryAndHseDiary = (a, b) => {
        return typeRoute === 'project_summary' || typeRoute === 'hse_diary' ? a : b
    }

    /* 请求日历上的数据 */
    const getCalendarData = useCallback(
        (yearDate, id = locationId) => {
            const startMonth = yearDate + '-01-01'
            const endMonth = yearDate + '-12-01'
            const isProjectSummary = typeRoute === 'project_summary'
            const calendarParams = isProjectSummary
                ? {
                      dateType: 'month',
                      startMonth, // 日历开始日期
                      endMonth, // 日历结束日期
                      year: yearDate,
                      locationId: null, // 船 ID
                      projectId: userInfo?.user?.projectId, // 项目 ID
                  }
                : {
                      dateType: 'month',
                      startMonth, // 日历开始日期
                      endMonth, // 日历结束日期
                      year: yearDate,
                      locationId: id, // 船 ID
                      projectId: userInfo?.user?.projectId, // 项目 ID
                  }
            dispatch(typeApi(calendarParams)) // 请求日历上的数据
        },
        [locationId, userInfo]
    )
    /* 初始化 - 获取 location 数据 */
    useEffect(() => {
        if (!userInfo) return
        dispatch(getLocationListDataAction(userInfo.user.projectId))
    }, [userInfo])
    /* 初始化 - 获取日历数据 */
    useEffect(() => {
        const isTrue =
            typeRoute === 'project_summary'
                ? !userInfo
                : !userInfo || !locationId
        if (isTrue) return
        getCalendarData(yearDate) // 初始化日历上的数据
    }, [userInfo, locationId])

    // 渲染年视图
    const renderYearView = () => {
        const months = []
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let validRange = yearDateValidRange()
        for (let i = 0; i < 12; i++) {
            const monthKey = `${yearDate}-${String(i + 1).padStart(2, '0')}`
            const className = `month-content month-${i}`
            const isValid = validRange?.start.substring(0, 7) <= monthKey && validRange?.end > monthKey
            let comment
            if (typeRoute === 'project_summary') {
                comment = calendarData?.find(item => item.month === i + 1)?.operationSummary
            } else {
                comment = calendarData?.find(item => item.month === i + 1)?.comment
            }
            months.push(
                <div key={i} className={`month-cell ${isValid ? '' : 'disabled-month-cell'}`}>
                    <div className='month-header'>
                        <div className='month-count'> {monthNames[i]}</div>
                    </div>
                    <div
                        className={className}
                        onClick={() => {
                            if (!isValid) return
                            if (typeRoute !== 'project_summary') {
                                if (!locationId) {
                                    message.warning(t('common.tips10'))
                                    return
                                }
                            }
                            dispatch(typeSlice.actions.addCalendarInfo(monthKey)) // 点击单元格，本地存储点击的日历信息
                            navigate(selectedKeys[0] + '/monthDetail', {
                                state: { authLocationList, typeRoute, month: i + 1, yearDate },
                            })
                        }}
                    >
                        <div className='samll-Box'>{comment}</div>
                    </div>
                </div>
            )
        }
        const ValidRange = yearDateValidRange()
        return (
            <div className='year-view-container'>
                <div
                    className='year-header'
                    style={{ width: language === 'zh' ? 'calc(100vw - 460px)' : 'calc(100vw - 475px)' }}
                >
                    <div>
                        <button
                            type='button'
                            title='Previous Year'
                            aria-pressed='false'
                            className={`fc-prev-button fc-button fc-button-primary ${
                                ValidRange?.isStart ? '' : 'disabled-icon'
                            }`}
                            onClick={() => {
                                if (ValidRange?.isStart) {
                                    changeYear(-1)
                                    getCalendarData(yearDate - 1) // 初始化日历上的数据
                                }
                            }}
                        >
                            <span class='fc-icon fc-icon-chevron-left'></span>
                        </button>
                        <button
                            type='button'
                            title='Next Year'
                            disabled=''
                            aria-pressed='false'
                            className={`fc-next-button fc-button fc-button-primary ${
                                ValidRange?.isEnd ? '' : 'disabled-icon'
                            }`}
                            onClick={() => {
                                if (ValidRange?.isEnd) {
                                    changeYear(+1)
                                    getCalendarData(Number(yearDate) + 1) // 初始化日历上的数据
                                }
                            }}
                        >
                            <span class='fc-icon fc-icon-chevron-right'></span>
                        </button>
                    </div>
                    <Button
                        className='thisYear'
                        onClick={() => {
                            dispatch(FleetSummarySlice.actions.addYearDate(String(new Date().getFullYear())))
                        }}
                    >
                        {t('common.calendar.thisYear')}
                    </Button>
                </div>
                <div className='monthAllBox'>
                    <div className='months-grid'>{months}</div>
                </div>
            </div>
        )
    }

    /* 默认 location */
    useEffect(() => {
        if (locationData?.length === 0) return
        const result = locationData?.find(p => p.id === locationId)
        if (!result && locationData) {
            dispatch(LocationSlice.actions.addLocationId(locationData[0].id))
            dispatch(LocationSlice.actions.addLocationName(locationData[0].name))
            dispatch(LocationSlice.actions.addlocationType(locationData[0].locationType)) // 设置 location Type
        }
    }, [locationData])

    useEffect(() => {
        if (!typeRoute) return
        dispatch(getALocationDataAction(typeRoute)) // 场所信息
    }, [typeRoute])

    if (!userInfo) return <></>

    return (
        <Card className='calendar-card-year'>
            {/* 选择日期范围 */}
            <DatePicker
                onChange={handleDatePicker}
                value={moment(yearDate)}
                picker='year'
                className='datePickerBtn'
                allowClear={false}
                disabledDate={currentDate => {
                    const current = currentDate.format('YYYY-MM-DD')
                    return current < userInfo?.project?.startDate || current > userInfo?.project?.endDate
                }}
            />
            {congruentLocation && (
                <div className='customBtn'>
                    {locationData?.length > 0 || !locationData ? (
                        <Select
                            onChange={(value, locationData) => {
                                dispatch(LocationSlice.actions.addLocationId(locationData?.id)) // 设置 location id
                                dispatch(LocationSlice.actions.addLocationName(locationData?.name)) // 设置 location 名称
                                dispatch(LocationSlice.actions.addlocationType(locationData?.type)) // 设置 location Type
                                const startDay = yearDate + '-01-01'
                                const endDay = yearDate + '-12-01'
                                getCalendarData(startDay, endDay, locationData?.id) // 获取日历上的数据
                            }}
                            value={locationId ? { label: locationName, value: locationId } : t('common.calendar.tips1')}
                            className={`locationBtn`}
                            options={locationData?.map(item => ({
                                label: item.name,
                                value: item.id,
                                id: item.id,
                                name: item.name,
                                type: item.locationType,
                            }))}
                        />
                    ) : (
                        <div
                            className={`locationBtn creatLocationBtn`}
                            onClick={() => {
                                const path = '/setting/resources/locations'
                                dispatch(NavSlice.actions.addSelectedKeys([path])) // 记住 menu 选中状态
                                navigate(path)
                            }}
                        >
                            {t('common.calendar.tips2')}
                        </div>
                    )}
                </div>
            )}
            {/* 月视图 */}
            {isShowProjectSummaryAndHseDiary(btnType === 'dayGridMonth' && renderYearView(), null)}
        </Card>
    )
}
